import { render } from "./nationality.vue?vue&type=template&id=4559b642&scoped=true"
import script from "./nationality.vue?vue&type=script&lang=js"
export * from "./nationality.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./nationality.vue?vue&type=style&index=1&id=4559b642&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4559b642"]])

export default __exports__